import React, { useState } from 'react';
import FormUsersList from '../teams/FormUsersList';
import RefExtractionModal from './Refextractionmodal';


const UnstructuredThreadForm = ({ 
  editingThread, 
  formData, 
  setFormData, 
  selectedUsers, 
  setSelectedUsers, 
  files, 
  setFiles,
  refExtractFiles,        // Add this line
  setRefExtractFiles,     // Add this line
  onSubmit, 
  onCancel
}) => {
  const [tagInput, setTagInput] = useState('');
  const [showRefModal, setShowRefModal] = useState(false);
  // const [refExtractFiles, setRefExtractFiles] = useState(new Set());
  
    // API base URL
  const API_BASE_URL = '/pceapi/threads/unstructured';

  // Handle form input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
const sanitizeFileName = (fileName) => {
  const lastDotIndex = fileName.lastIndexOf('.');
  const name = fileName.substring(0, lastDotIndex);
  const extension = fileName.substring(lastDotIndex);

  // Only strip characters that are actually unsafe in an S3 key / Windows
  let sanitizedName = name.replace(/\s/g, '-')  // spaces to hyphens
                         .replace(/[<>:"/\\|?*\x00-\x1F]/g, '-')  // filesystem/S3-unsafe chars to hyphens
                         .replace(/-+/g, '-');  // collapse multiple hyphens to single
  if (extension == '.pptx'){
                         sanitizedName = sanitizedName.slice(0, 40);}
  return sanitizedName + extension;
};
  // Handle file selection
//   const handleFileChange = (e) => {
//     const { name, files } = e.target;
//     const sanitizedFiles = Array.from(files).map(file => {
//     const sanitizedName = sanitizeFileName(file.name);
//     return {
//         file: new File([file], sanitizedName, { type: file.type }),
//         id: crypto.randomUUID()
//     };
// });
// setFiles(prev => ({ ...prev, [name]: sanitizedFiles }));
//   };
  // Handle file selection
const handleFileChange = (e) => {
  const { name, files: selectedFiles } = e.target;
  
  // Get current file IDs from this category before replacing
  const oldCategoryFiles = files[name] || [];
  const oldFileIds = oldCategoryFiles.map(item => item.id);
  
  // Remove old file IDs from refExtractFiles
  if (oldFileIds.length > 0) {
    setRefExtractFiles(prev => {
      const newSet = new Set(prev);
      oldFileIds.forEach(id => newSet.delete(id));
      return newSet;
    });
  }
  
  // Handle cancel (no files selected)
  if (selectedFiles.length === 0) {
    setFiles(prev => ({ ...prev, [name]: [] }));
    return;
  }
  
  // Sanitize and add new files
  const sanitizedFiles = Array.from(selectedFiles).map(file => {
    const sanitizedName = sanitizeFileName(file.name);
    return {
      file: new File([file], sanitizedName, { type: file.type }),
      id: crypto.randomUUID()
    };
  });
  
  setFiles(prev => ({ ...prev, [name]: sanitizedFiles }));
};
  // Handle access level change
  const handleAccessLevelChange = (e) => {
    const value = e.target.value;
    setFormData(prev => ({ ...prev, thread_access_level: value }));
    
    // If switching to PUBLIC, clear user access selections
    if (value === 'PUBLIC') {
      setSelectedUsers([]);
    }
  };

  // Handle user selection for access
  const handleUserSelection = (userId) => {
    if (selectedUsers.includes(userId)) {
      setSelectedUsers(prev => prev.filter(id => id !== userId));
    } else {
      setSelectedUsers(prev => [...prev, userId]);
    }
  };

  // Handle adding a tag
  const handleAddTag = () => {
    if (tagInput.trim() !== '' && !formData.tags.includes(tagInput.trim())) {
      setFormData(prev => ({
        ...prev,
        tags: [...prev.tags, tagInput.trim()]
      }));
      setTagInput('');
    }
  };

  // Handle removing a tag
  const handleRemoveTag = (tagToRemove) => {
    setFormData(prev => ({
      ...prev,
      tags: prev.tags.filter(tag => tag !== tagToRemove)
    }));
  };

  // Handle tag input keydown (for Enter key)
  const handleTagKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddTag();
    }
  };
const getTotalFilesCount = () => {
    return Object.values(files).reduce((acc, arr) => acc + (arr?.length || 0), 0);
};

const getRefExtractInfo = () => {
    return Array.from(refExtractFiles).map(fileId => {
        const [category, index, ...nameParts] = fileId.split('_');
        return {
            category: category,
            index: parseInt(index),
            fileName: nameParts.join('_')
        };
    });
};
  return (
    <div className="ev-card-2 w-100 ev-padding-xlarge">
      <p className="ev-med-p-dark mb-4">
        {editingThread ? 'Edit Data Collection Details' : 'Create Data Collection'}
      </p>
      
      <form onSubmit={(e) => {
    e.preventDefault();
    onSubmit(e, refExtractFiles);
}}>
        <div className="row">
          <div className="col-6">
            <div className="form-group mb-3">
              <label className="ev-reg-p-dark mb-2">Data Collection Name <span className="text-danger">*</span></label>
              <input 
                type="text" 
                className="formField3" 
                name="name" 
                value={formData.name} 
                onChange={handleInputChange} 
                required 
              />
            </div>
            <div className="row">
              <div className="col-5">
                <div className="form-group mb-3">
                  <label className="ev-reg-p-dark mb-1">Access Level <span className="text-danger">*</span></label>
                  <div className="btn-group custom-btn-group-outer w-100" role="group" aria-label="Access Level Selection">
                    <button 
                      type="button" 
                      className={`btn custom-btn-group-inner ${formData.thread_access_level === 'PUBLIC' ? 'ev-btn-blue-fill-round' : 'ev-btn-lightblue-fill-round'}`}
                      onClick={() => handleAccessLevelChange({ target: { name: 'thread_access_level', value: 'PUBLIC' } })}
                    >
                      Public
                    </button>
                    <button 
                      type="button" 
                      className={`btn custom-btn-group-inner ${formData.thread_access_level === 'PRIVATE' ? 'ev-btn-blue-fill-round' : 'ev-btn-lightblue-fill-round'}`}
                      onClick={() => handleAccessLevelChange({ target: { name: 'thread_access_level', value: 'PRIVATE' } })}
                    >
                      Private
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-7">
                <div className="form-group mb-4">
                  <label className="ev-reg-p-dark mb-1">Meta Tags <span className="ev-small-p-blue"><i>(Optional)</i></span></label>
                  <div className="d-flex mb-2">
                    <input 
                      type="text" 
                      className="formField3 ev-btn-reg"
                      value={tagInput} 
                      onChange={(e) => setTagInput(e.target.value)} 
                      onKeyDown={handleTagKeyDown}
                      placeholder="Enter tag and press Enter" 
                    />
                    <button 
                      type="button" 
                      className="ev-btn-blue-fill-round ev-bold-reg ev-radius-small ms-1" 
                      onClick={handleAddTag}
                    >
                      Add
                    </button>
                  </div>
                  <div className="d-flex flex-wrap gap-2 mt-2">
                    {formData.tags.map((tag, index) => (
                      <span key={index} className="ev-message-card3 ev-btn-small">
                        {tag}
                        <button 
                          type="button" 
                          className="btn-close ev-btn-text-only-fill p-0 ms-2 me-0" 
                          onClick={() => handleRemoveTag(tag)}
                        ><i className ="bi bi-x-circle"></i></button>
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            
            {formData.thread_access_level === 'PRIVATE' && (
              <div className="form-group mb-4">
                <label className="ev-reg-p-dark mb-1">User Access <span className="ev-small-p-blue"><i>(Optional)</i></span></label>
                <FormUsersList 
                  apiBaseUrl={API_BASE_URL}
                  selectedUsers={selectedUsers}
                  onSelectUser={handleUserSelection}
                  ownerEmail={editingThread ? editingThread.created_by_email : null}
                />
              </div>
            )}
          </div>
          
          <div className="col-6">
            <div className="form-group mb-0">
              <div className="d-flex justify-content-between align-items-center mb-1">
    <label className="ev-reg-p-dark mb-1">Documents <span className="ev-small-p-blue"><i>(Optional)</i></span></label>
    {getTotalFilesCount() > 0 && (
        <button
            type="button"
            className="ev-btn-blue-outline-round ev-btn-small"
            onClick={() => setShowRefModal(true)}
        >
            <i className="bi bi-bookmark-check me-1"></i>
            Reference Extraction ({refExtractFiles.size}/{getTotalFilesCount()})
        </button>
    )}
</div>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <div className="ev-card-3 border-2 p-2">
                    <div className="card-body p-1">
                      <div className ="text-danger">
                        <h3 className="mb-2">
                        <i className="bi bi-file-earmark-pdf"></i>
                        </h3>
                        <h6 className="ev-fs-12 mb-1">
                        PDF Documents
                        </h6>
                      </div>
                      <input
                        type="file"
                        name="pdfFiles"
                        onChange={handleFileChange}
                        multiple
                        accept=".pdf"
                        className="form-control form-control-sm choose-files"
                      />
                    </div>
                  </div>
                </div>
                
                <div className="col-md-6 mb-3">
                  <div className="ev-card-3 border-2 p-2">
                    <div className="card-body p-1">
                      <div className ="text-primary">
                        <h3 className="mb-2">
                        <i className="bi bi-file-earmark-word"></i>
                        </h3>
                        <h6 className="ev-fs-12 mb-1">
                          Word Documents
                        </h6>
                      </div>
                      <input
                        type="file"
                        name="wordFiles"
                        onChange={handleFileChange}
                        multiple
                        accept=".doc,.docx"
                        className="form-control form-control-sm choose-files"
                      />
                    </div>
                  </div>
                </div>
                
                <div className="col-md-6 mb-3">
                  <div className="ev-card-3 border-2 p-2">
                    <div className="card-body p-1">
                      <div className ="text-secondary">
                        <h3 className="mb-2">
                        <i className="bi bi-file-earmark-text"></i>
                        </h3>
                        <h6 className="ev-fs-12 mb-1">
                        Text Documents
                        </h6>
                      </div>
                      <input
                        type="file"
                        name="textFiles"
                        onChange={handleFileChange}
                        multiple
                        accept=".txt"
                        className="form-control form-control-sm choose-files"
                      />
                    </div>
                  </div>
                </div>
                
                <div className="col-md-6 mb-3">
                  <div className="ev-card-3 border-2 p-2">
                    <div className="card-body p-1">
                      <div className ="text-orange">
                        <h3 className="mb-2">
                        <i className="bi bi-file-earmark-ppt"></i>
                        </h3>
                        <h6 className="ev-fs-12 mb-1">
                          Powerpoint Documents
                        </h6>
                      </div>
                      <input
                        type="file"
                        name="pptFiles"
                        onChange={handleFileChange}
                        multiple
                        accept=".ppt,.pptx"
                        className="form-control form-control-sm choose-files"
                      />
                    </div>
                  </div>
                </div>
                
                <div className="col-md-6 mb-3">
                  <div className="ev-card-3 border-2 p-2">
                    <div className="card-body p-1">
                      <div className ="text-success">
                        <h3 className="mb-2">
                        <i className="bi bi-file-earmark-excel"></i>
                        </h3>
                        <h6 className="ev-fs-12 mb-1">
                          Excel Documents
                        </h6>
                      </div>
                      <input
                        type="file"
                        name="excelFiles"
                        onChange={handleFileChange}
                        multiple
                        accept=".xls,.xlsx, .xlsm"
                        className="form-control form-control-sm choose-files"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <div className="ev-card-3 border-2 p-2">
                    <div className="card-body p-1">
                      <div className ="text-success">
                        <h3 className="mb-2">
                        <i className="bi bi-filetype-csv"></i>
                        </h3>
                        <h6 className="ev-fs-12 mb-1">
                          CSV Documents
                        </h6>
                      </div>
                      <input
                        type="file"
                        name="csvFiles"
                        onChange={handleFileChange}
                        multiple
                        accept=".csv"
                        className="form-control form-control-sm choose-files"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {editingThread ? (
              <div className="alert alert-info mt-0" >
                <i className="bi bi-info-circle me-1"></i>
                <b>Note:</b> Uploading new documents will add them to the existing Data Collection. 
              </div>
            ) : (
              <div className="alert alert-primary mt-0">
                <i className="bi bi-info-circle me-1"></i>
                <b>Note:</b> You can always upload new documents later by editing this Data Collection.
              </div>
            )}
            <div className="mt-2 text-end" >
              <button type="submit" className="ev-btn-blue-fill-round ev-bold-reg" >
                <i className="bi bi-cursor-fill"></i> {editingThread ? 'Update Data Collection' : 'Create Data Collection'}
              </button>
              <button 
                type="button" 
                className="ev-btn-blue-outline-round ms-2" 
                onClick={onCancel}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </form>
      <RefExtractionModal
        show={showRefModal}
        onClose={() => setShowRefModal(false)}
        files={files}
        refExtractFiles={refExtractFiles}
        setRefExtractFiles={setRefExtractFiles}
      />
    </div>
  );
};

export default UnstructuredThreadForm;